import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";

export default function RequireAdmin({ children }: PropsWithChildren) {
  const { admin, isBootstrapping } = useAdminAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return (
      <div className="ego-shell flex min-h-screen items-center justify-center px-4">
        <div className="ego-surface w-full max-w-sm px-8 py-10 text-center">
          <h1 className="text-xl font-bold text-foreground">Restoring session</h1>
          <p className="mx-auto mt-2 max-w-xs text-sm text-muted-foreground">
            One moment while we open your exhibitor workspace.
          </p>
          <div className="mx-auto mt-7 h-9 w-9 animate-spin rounded-full border-[3px] border-[var(--pp-gold)] border-t-transparent" />
        </div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
